export default "__VITE_ASSET__jH8gnLSUeIu1dQP7KoWL7g__"